"use strict";

PF.FileOne = class FileOne extends PF.Widget
	{
	static get options()
		{
		return {
			addable: true,
			deletable: true,
			selectable: true,

			modelsConfig: {},
			title: '&nbsp;',
			enableHeader: true,
			dummyText: "Нет файлов",
			enableDummy: true,
			serialIndex: 'serial_num',

			html: PF.FileOne.templates,
			fileInputConfig: {
				dom: {
					element: undefined
				},
				multiple: false,
				accept: '*',
				previewTypes: ['img/h80', 'img/h60']
			},
			imgListConfig: {
				searchable: false,
				addable: false,
				deletable: false,
				sortable: true,
				sortDir: 'h',
				dom: {
					element: undefined,
				},
				html: {
					wrapper: PF.FileList.templates.imgListWrapper
				},
				itemClass: PF.FileList.ImgItem,
			},
			docListConfig: {
				searchable: false,
				addable: false,
				deletable: false,
				sortable: true,
				enableHeader: false,
				dom: {
					element: undefined,
				},
				html: {
					wrapper: PF.FileList.templates.docListWrapper
				},
				itemClass: PF.FileList.DocItem,
				viewPopupConfig: {
					html: {
						content: PF.FileList.templates.docPopupContent,
						popup: PF.FileList.templates.docPopup,
					}
				},
			},
			photoBrowserConfig: {
				routableModals: false,
				photos: [],
				navbarOfText: "из",
				theme: 'dark',
				type: 'popup',
				renderNavbar: PF.FileList.renderBrowserNawbar
			},
			unknownPreview: 'img/static-previews/unknown.svg',
			processFile: () => {
			},
		};
		}

	static get templates()
		{
		return {
			//language=HTML
			wrapper: `
				<div class="pf-file-list-crud-header" pf="header">

					<div class="title-row" pf="titleRow">
						<div class="title" pf="title"></div>
					</div>
					<div class="actions">
						<label class="link" style="display: none" pf="add">
							<i class="material-icons">add</i>
							<input multiple type="file" pf="addInput" style="display: none"/>
						</label>
						<!--						<a class="link" style="display: none" pf="add"><i class="material-icons">add</i></a>-->
						<a class="link" style="display: none" pf="selectAll"><i class="material-icons">select_all</i></a>
						<a class="link" style="display: none" pf="delete"><i class="material-icons">delete</i></a>
					</div>
				</div>
				<div class="pf-list-wrapper" pf="wrapper">
					<div pf="imgContainer" style="width: 100%; overflow: auto; position: relative"></div>
					<div pf="docContainer" style="position: relative"></div>
					<!--					<div class="preloader-container" pf="preloaderContainer">-->
					<!--						<div class="preloader" pf="preloader"></div>-->
					<!--					</div>-->
					<div class="pf-list-dummy" pf="dummy"><p pf="dummyText"></p>
					</div>
				</div>
			`,
			//language=HTML
			imgListWrapper: `
				<div pf="wrapper">
					<div style="display: flex; justify-content: flex-start;padding: 8px" pf="ul">
					</div>
					<div class="preloader-container" pf="preloaderContainer">
						<div class="preloader" pf="preloader"></div>
					</div>
				</div>
			`,
			//language=HTML
			docListWrapper: `
				<div pf="wrapper">
					<div pf="ul">
					</div>
					<div class="preloader-container" pf="preloaderContainer">
						<div class="preloader" pf="preloader"></div>
					</div>
				</div>
			`,
			//language=HTML
			docPopupContent: `
				<iframe src="" pf="iframe" style="width: 100%;height: 100%;">
				</iframe>
			`,
			//language=HTML
			docPopup: `
				<div class="popup page">
					<div class="navbar" pf="navBar">
						<div class="navbar-bg"></div>
						<div class="navbar-inner" pf="navbarInner">
							<div class="left">
								<a href="#" class="link " pf="close">
									<i class="icon icon-back"></i>
								</a>
							</div>
							<div class="center" pf="popupTitle"></div>
							<div class="right">
								<a href="#" class="link" pf="download">
									<i class="material-icons">cloud_download</i>
								</a>
								<a href="#" class="link" pf="delete">
									<i class="material-icons">delete</i>
								</a>
							</div>
						</div>
					</div>
					<div class="page-content" pf="pageContent">
					</div>
				</div>
			`

		};
		}

	init()
		{
		// if (this.model === undefined)
		// 	{
		// 	this.modelsConfig.list = this;
		// 	this.models = new PF.Models(this.modelsConfig);
		// 	}
		// else
		// 	{
		// 	this.models.list = this;
		// 	PF.Options.assignOptions(this.models, this.modelsConfig);
		// 	}

		this.dom.load(this.html.wrapper, 'wrapper');
		this.dom.element.append(this.dom.wrapper);
		this.dom.element.addClass('pf-file-list');

		if (this.dom.header !== undefined)
			{
			this.bindDom({header: 'show'}, 'enableHeader');
			this.bindDom({title: 'html'}, 'title');
			}
		// if (this.dom.preloaderContainer !== undefined)
		// 	{
		// 	this.dom.preloader.append(this.dom.preloaderContent);
		// 	this.bindDom({preloaderContainer: 'show'}, 'models.loading');
		// 	}
		if (this.dom.dummy !== undefined)
			{
			// this.bindDom({ul: 'hide'}, 'models.filterLength', (filterLength) => filterLength === 0);
			this.bindDom({dummy: 'show'}, [
				'model.file',
				'enableDummy'
			], (file, enableDummy) => {
				return (file === null || file === undefined) && enableDummy === true;
			});
			this.bindDom({dummy: 'text'}, 'dummyText');
			}


		this.docListConfig.dom.element = this.dom.docContainer;
		this.docList = new PF.List({
			...this.docListConfig,
			fileList: this
		});
		this.docList.on('sort', () => this.trigger('sort'));
		this.bindDom({docContainer: 'show'}, 'docList.size', (s) => s > 0);

		this.imgListConfig.dom.element = this.dom.imgContainer;
		this.imgList = new PF.List({
			...this.imgListConfig,
			fileList: this
		});
		this.imgList.on('sort', () => this.trigger('sort'));
		this.bindDom({imgContainer: 'show'}, 'imgList.size', (s) => s > 0);

		this.initPhotoBrowser();
		// this.models.on('addOne', this.addOneSlot.bind(this));

		this.useTrait(PF.FileOne.Add, this.addable);
		this.useTrait(PF.FileOne.Select, this.selectable);
		this.useTrait(PF.FileOne.Delete, this.deletable);

		this.recreateList();
		}

	initPhotoBrowser()
		{
		this.id = PF.H.randomString();
		this.photoBrowser = app.f7.photoBrowser.create({
			...this.photoBrowserConfig,
			deletable: this.deletable,
			id: this.id
		});
		let doc = new PF.Dom.Node(document);
		doc.onDelegate(`#photoBrowserDelete-${this.id}`, 'click', () => {
			let index = this.photoBrowser.activeIndex;
			this.imgList[index].delete();
		});
		doc.onDelegate(`#photoBrowserDownload-${this.id}`, 'click', () => {
			let index = this.photoBrowser.activeIndex;
			PF.Model.File.download(this.imgList[index].model.file.full_url);
		});
		}

	recreateList()
		{
		// for (let i = 0; i < this.models.length; i++)
		// 	{
		// 	this.addOneSlot(this.models[i]);
		// 	}
		if (this.model.get(this.key, null, null) !== null)
			{
			this.addOneSlot(this.model);
			}
		}

	addOneSlot(model)
		{
		if (model.get(`file.type`).includes('image'))
			{
			this.imgList.models.push(model);
			}
		else
			{
			this.docList.models.push(model);
			}
		}

	create(model)
		{
		return PF.H.create(this.itemClass, {list: this, model: model});
		}

	removeSlot(removedItems)
		{
		for (let i = 0; i < removedItems.length; i++)
			{
			for (let j = 0; j < this.length; j++)
				{
				if (PF.H.compareByPks(this[j].model, removedItems[i]))
					{
					this[j].destroy();
					this.splice(j, 1);
					break;
					}
				}
			}
		}


	static renderBrowserNawbar()
		{
		const pb = this;
		let iconsColor = pb.params.iconsColor;
		if (!pb.params.iconsColor && pb.params.theme === 'dark')
			{
			iconsColor = 'white';
			}
		const backLinkText = (pb.app.theme === 'ios' || pb.app.theme === 'aurora') && pb.params.backLinkText ? pb.params.backLinkText : '';
		const isPopup = pb.params.type !== 'page';
		//language=HTML
		const navbarHtml = `
			<div class="navbar">
			  <div class="navbar-inner sliding">
				 <div class="left">
					<a class="link ${isPopup ? 'popup-close' : ''} ${!backLinkText ? 'icon-only' : ''} ${!isPopup ? 'back' : ''}" ${isPopup ? 'data-popup=".photo-browser-popup"' : ''}>
					  <i class="icon icon-back ${iconsColor ? `color-${iconsColor}` : ''}"></i>
					  ${backLinkText ? `<span>${backLinkText}</span>` : ''}
					</a>
				 </div>
				 <div class="title">
					<span class="photo-browser-current"></span>
					<span class="photo-browser-of">${pb.params.navbarOfText}</span>
					<span class="photo-browser-total"></span>
				 </div>
				 <div class="right">
					<a href="#" id="photoBrowserDownload-${pb.params.id}" class="link " >
						<i class="material-icons">cloud_download</i>
					</a>
					${pb.params.deletable ? `
						<a href="#" id="photoBrowserDelete-${pb.params.id}" class="link" >
							<i class="material-icons">delete</i>
						</a>
					` : ''}							
				 </div>
			  </div>
			</div>
		 `;
		return navbarHtml;
		}


	};


PF.FileOne.Add = class Add extends PF.Trait
	{
	initTrait()
		{
		this.dom.add.show();
		this.fileInput = new PF.FileInput({
			...this.fileInputConfig,
			dom: {element: this.dom.addInput},
		});
		this.fileInput.on('files-readed', () => this.addFiles());
		}

	addFiles()
		{
		if (this.model.get(this.key) !== null)
			{
			this.imgList.models.splice(0, this.imgList.models.length);
			this.docList.models.splice(0, this.docList.models.length);
			}

		for (let i = 0; i < this.fileInput.files.length; i++)
			{
			// let newModel = this.models.createNewItem({file: this.fileInput.files[i]});
			// newModel.setData(this.serialIndex, this.models.length);
			let file = this.fileInput.files[i];
			this.processFile(file);

			this.model.setData(this.key, file);//new PF.Model.File({raw: this.fileInput.files[i], previewTypes: ['img/h80', 'img/h60']}));
			this.model.options.isNewRecord = true;
			this.recreateList();
			}
		}

	};

PF.FileOne.Select = class Select extends PF.Trait
	{
	initTrait()
		{
		this.bindDom({selectAll: 'show', delete: 'show'}, 'selectMode');
		this.dom.selectAll.on('click', () => this.selectAll());

		this.selectMode = false;
		this.selected = [];
		}

	selectAll()
		{
		let select = this.selected.length < this.docList.length + this.imgList.length;
		for (let i = 0; i < this.docList.length; i++)
			{
			this.docList[i].selectState = select;
			}
		for (let i = 0; i < this.imgList.length; i++)
			{
			this.imgList[i].selectState = select;
			}
		this.selectMode = true;
		}
	};

PF.FileOne.Delete = class Delete extends PF.Trait
	{
	initTrait()
		{
		this.dom.delete.on('click', () => this.deleteSelected());
		}

	deleteSelected()
		{
		for (let i = 0; i < this.selected.length; i++)
			{
			this.selected[i].delete(false);
			}
		if (this.toastOnDelete === true)
			{
			this.models.once('delete-marked-success', () => app.toast(this.toastOnDeleteText));
			}
		this.models.delete();
		this.selectMode = false;
		this.imgList.reindex();
		this.docList.reindex();
		}
	};
